<template>
    <div class="course-categories">
        <div class="categories-bar">
            <div class="icon-container" @click="toggleMenu">
                <img src="../assets/icons/bars.svg" alt="Barra de categoria"  :class="{ rotate: isMenuOpen }">
            </div>
            <div class="category-button" @click="toggleMenu">
                <span class="text">Categorias</span>
            </div>
            <div class="alphabetic-filter">
                <button @click="toggleAlphabeticOrder" class="btn-alphabetic">
                    <i :class="['fas', isAlphabetic ? 'fa-sort-alpha-down' : 'fa-sort-alpha-up']"></i>
                    <span>{{ isAlphabetic ? 'A-Z' : 'Z-A' }}</span>
                </button>
            </div>
        </div>

        <div v-if="isMenuOpen" class="category-dropdown">
            <div v-if="loading" class="loading-categories">
                Carregando categorias...
            </div>
            <div v-else class="category-grid">
                <div 
                    v-for="category in categories" 
                    :key="category.codigo_grupo" 
                    class="category-item"
                    :class="{ active: selectedCategoryId === category.codigo_grupo }"
                    @click="selectCategory(category)"
                >
                    {{ category.nome_grupo }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../styles/CourseCategories.css';
import request from '../router/request';

export default {
    name: 'CourseCategories',
    data() {
        return {
            isMenuOpen: false,
            isAlphabetic: true,
            categories: [],
            loading: false,
            selectedCategoryId: null
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            if (this.isMenuOpen && this.categories.length === 0) {
                this.loadCategories();
            }
        },
        async loadCategories() {
            this.loading = true;
            try {
                const response = await request.post('/portal/listarGruposConhec');
                this.categories = [{ codigo_grupo: null, nome_grupo: 'Todos' }, ...response.data];
                console.log('Categorias carregadas:', this.categories);
            } catch (error) {
                console.error('Erro ao carregar categorias:', error);
                this.categories = [{ codigo_grupo: null, nome_grupo: 'Todos' }];
            } finally {
                this.loading = false;
            }
        },
        selectCategory(category) {
            this.selectedCategoryId = category.codigo_grupo;
            if (category.codigo_grupo === null) {
                this.$emit('category-selected', null);
            } else {
                this.$emit('category-selected', category);
            }
            this.isMenuOpen = false;
        },
        toggleAlphabeticOrder() {
            this.isAlphabetic = !this.isAlphabetic;
            this.$emit('alphabetic-order-changed', this.isAlphabetic);
        }
    },
    mounted() {
        this.loadCategories();
    }
};
</script>